// extracted by mini-css-extract-plugin
export default {"table":"webpack-concepts-Extraction-Blocks-Table-BaseTable-BaseTable-module__table","header":"webpack-concepts-Extraction-Blocks-Table-BaseTable-BaseTable-module__header"};